export class Collabo
{
id:string;
name:string;
numberType:string;
percent:string;
fees:string;
hours:string;
}
